import * as z from 'zod';
import { instagramUsernameValidation } from '../../commonValidation';

const MediaImg = z
  .object({
    image: z.string(),
    cdn01: z.string(),
  })
  .passthrough();

const MediaVideo = z
  .object({
    video: z.string(),
    cdn01: z.string(),
  })
  .passthrough();

const notLiveProfileSchema = z.object({
  firstName: z.string().trim().min(1, { message: 'Required' }),
  lastName: z.string().trim().min(1, { message: 'Required' }),

  customColorSchema: z.object({ primaryColor: z.string() }),
  gender: z.union([z.literal('M'), z.literal('F')]).nullable(),

  profileInstagram: instagramUsernameValidation,
  profileTiktok: z
    .string()
    .refine((v) => !v.startsWith('@'), { message: `Do not include @` })
    .nullable(),
  profileYoutubeChannel: z
    .string()
    .refine((v) => !v || v.startsWith('https://'), {
      message: `Provide full link`,
    })
    .nullable(),

  title: z.string().trim().min(1, { message: 'Required' }),
  messageProfile: z.string(),
  accomplishments: z.string(),

  mediaAvatar: MediaImg.nullable().optional(),
  mediaCover: MediaImg.nullable().optional(),
  mediaBanner: MediaImg.nullable().optional(),
  mediaWelcome: MediaVideo.nullable().optional(),

  keywords: z.array(z.string()).default([]), // tags
});

export const liveProfileSchema = notLiveProfileSchema.extend({
  mediaAvatar: MediaImg.required(),
  mediaCover: MediaImg.required(),
});

export type NotLiveProfile = z.infer<typeof notLiveProfileSchema>;
export type LiveProfile = z.infer<typeof liveProfileSchema>;

export default notLiveProfileSchema;
